import React from 'react';
import { useAppContext } from '../../context/AppContext';

export const SplashScreen: React.FC = () => {
    const { db } = useAppContext();
    const wl = db.globalConfig?.whiteLabel;
    const splashLogo = (wl?.enabled && wl?.logos?.splashLogoUrl) ? wl.logos.splashLogoUrl : '/assets/splash_logo.webp';
    const appName = (wl?.enabled && wl?.appName) ? wl.appName : 'Padel Brothers';
    
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background animate-fadeOut" style={{ animationDelay: '2s', animationFillMode: 'forwards' }}>
            <div className="flex flex-col items-center animate-fadeIn">
                <img
                    src={splashLogo}
                    alt={appName}
                    fetchPriority="high"
                    width="384"
                    height="178"
                    className="w-64 md:w-80 object-contain animate-pulse-slow"
                />
            </div>
        </div>
    );
};
